
import React from 'react';
import Button from '../../../components/base/Button';

const AboutSection: React.FC = () => {
  const stats = [
    { number: '10,000+', label: 'Patients Treated' },
    { number: '98%', label: 'Satisfaction Rate' },
    { number: '15+', label: 'Years Experience' },
    { number: '24/7', label: 'Support Available' }
  ];

  const teamMembers = [
    {
      name: 'Dr. Sarah Mitchell',
      title: 'Chief Medical Officer',
      specialty: 'Hormone Optimization Specialist',
      image: 'https://public.readdy.ai/ai/img_res/ffd7092efb4ded211b87677a4bcaa473.jpg'
    },
    {
      name: 'Dr. Michael Chen',
      title: 'Peptide Therapy Director',
      specialty: 'Anti-Aging & Regenerative Medicine',
      image: 'https://readdy.ai/api/search-image?query=Professional%20male%20doctor%20in%20white%20coat%2C%20experienced%20medical%20professional%2C%20modern%20medical%20facility%20background%2C%20confident%20medical%20expert%2C%20healthcare%20specialist%2C%20professional%20medical%20portrait&width=400&height=500&seq=doctor-michael&orientation=portrait'
    },
    {
      name: 'Dr. Emily Rodriguez',
      title: 'Wellness Coordinator',
      specialty: 'Nutritional & IV Therapy',
      image: 'https://readdy.ai/api/search-image?query=Professional%20female%20doctor%20in%20medical%20attire%2C%20wellness%20specialist%2C%20modern%20healthcare%20setting%2C%20confident%20medical%20professional%2C%20nutritional%20medicine%20expert%2C%20professional%20medical%20portrait&width=400&height=500&seq=doctor-emily&orientation=portrait'
    }
  ];

  return (
    <section id="about" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Leading Innovation in <span className="text-blue-600">Telemedicine</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            The Simple MD combines cutting-edge medical technology with personalized care to deliver 
            exceptional <strong>telemedicine</strong> services. Our team of experts specializes in 
            <strong> bioidentical hormone optimization</strong> and advanced wellness treatments.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-20">
          {stats.map((stat, index) => (
            <div key={index} className="text-center">
              <div className="text-4xl md:text-5xl font-bold text-blue-600 mb-2">
                {stat.number}
              </div>
              <div className="text-gray-600 font-medium">
                {stat.label}
              </div>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center mb-20">
          <div>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
              Why Choose The Simple MD?
            </h2>
            <p className="text-lg text-gray-600 mb-6">
              Located in the heart of Miami, Florida, The Simple MD is revolutionizing healthcare delivery through innovative virtual primary care and advanced wellness treatments. Our cutting-edge approach combines convenience with clinical excellence.
            </p>
            <div className="space-y-6">
              <div className="flex items-start">
                <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                  <i className="ri-award-line text-blue-600 text-xl"></i>
                </div>
                <div>
                  <h4 className="text-xl font-semibold text-gray-900 mb-2">Board-Certified Physicians</h4>
                  <p className="text-gray-600">Our medical team consists of board-certified physicians with extensive experience in hormone therapy and regenerative medicine.</p>
                </div>
              </div>
              
              <div className="flex items-start">
                <div className="w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                  <i className="ri-microscope-line text-teal-600 text-xl"></i>
                </div>
                <div>
                  <h4 className="text-xl font-semibold text-gray-900 mb-2">Advanced Diagnostics</h4>
                  <p className="text-gray-600">State-of-the-art testing and analysis to create personalized treatment plans tailored to your unique needs.</p>
                </div>
              </div>
              
              <div className="flex items-start">
                <div className="w-12 h-12 bg-purple-100 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                  <i className="ri-shield-check-line text-purple-600 text-xl"></i>
                </div>
                <div>
                  <h4 className="text-xl font-semibold text-gray-900 mb-2">Safety First</h4>
                  <p className="text-gray-600">All treatments follow strict safety protocols and are monitored by our medical team throughout your journey.</p>
                </div>
              </div>
            </div>
          </div>
          
          <div>
            <img 
              src="https://readdy.ai/api/search-image?query=Modern%20telemedicine%20consultation%2C%20doctor%20and%20patient%20video%20call%2C%20advanced%20medical%20technology%2C%20digital%20healthcare%20interface%2C%20professional%20medical%20consultation%20setup%2C%20clean%20modern%20medical%20office%2C%20telemedicine%20equipment&width=600&height=500&seq=telemedicine-consultation&orientation=landscape"
              alt="Telemedicine Consultation"
              className="w-full h-96 object-cover object-top rounded-2xl shadow-2xl"
            />
          </div>
        </div>

        <div>
          <h3 className="text-3xl font-bold text-gray-900 text-center mb-12">
            Meet Our Expert Team
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {teamMembers.map((member, index) => (
              <div key={index} className="bg-gray-50 rounded-2xl p-8 text-center">
                <img 
                  src={member.image}
                  alt={member.name}
                  className="w-32 h-32 object-cover object-top rounded-full mx-auto mb-6"
                />
                <h4 className="text-xl font-bold text-gray-900 mb-2">{member.name}</h4>
                <p className="text-blue-600 font-semibold mb-2">{member.title}</p>
                <p className="text-gray-600">{member.specialty}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
